<template>
  <div :id="componentId" class="spm6-hero-banner" @mouseenter="stopAutoplay" @mouseleave="startAutoplay">
    <div class="spm6-hero-carousel">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="spm6-hero-slide"
        :class="{ active: index === currentIndex }"
      >
        <img class="spm6-hero-image" referrerpolicy="no-referrer" :src="item.imageUrl" @click="goTo(item.url)" />
      </div>
    </div>
    <div v-if="list.length > 1" class="spm6-hero-dots">
      <span
        v-for="(item, index) in list"
        :key="index"
        class="spm6-hero-dot"
        :class="{ active: index === currentIndex }"
        @click="goToIndex(index)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHeroBanner',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_1'
    }
  },
  data() {
    return {
      list: [
        { imageUrl: require('../../../special/SpecialSix/assets/img/hero_banner.png'), url: '' },
        { imageUrl: require('../../../special/SpecialSix/assets/img/hero_banner.png'), url: '' },
        { imageUrl: require('../../../special/SpecialSix/assets/img/hero_banner.png'), url: '' }
      ],
      currentIndex: 0,
      timer: null
    }
  },
  computed: {
    hasMultiple() {
      return this.list.length > 1
    }
  },
  mounted() {
    this.startAutoplay()
  },
  beforeDestroy() {
    this.stopAutoplay()
  },
  methods: {
    startAutoplay() {
      if (!this.hasMultiple) return
      this.stopAutoplay()
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.list.length
      }, 4000)
    },
    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    goToIndex(index) {
      this.currentIndex = index
      this.startAutoplay()
    },
    goTo(url) {
      if (!url) return
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.spm6-hero-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.spm6-hero-carousel {
  position: relative;
  width: 100%;
}

.spm6-hero-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.spm6-hero-slide.active {
  position: relative;
  opacity: 1;
}

.spm6-hero-image {
  width: 100%;
  height: auto;
  display: block;
  cursor: pointer;
}

.spm6-hero-dots {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  z-index: 10;
}

.spm6-hero-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  cursor: pointer;
}

.spm6-hero-dot.active {
  background: #fff;
}
</style>
